import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss']
})
export class DebugComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  mostrarInfo() {
    const info = `
    🧭 Navegador: ${navigator.appName}
    🌐 Versão: ${navigator.appVersion}
    📦 User Agent: ${navigator.userAgent}
    💻 Plataforma/SO: ${navigator.platform}
    🗣️ Idioma: ${navigator.language}
    📜 Suporte a JavaScript: ${typeof window !== 'undefined' && typeof document !== 'undefined' ? 'Sim' : 'Não'}
    🧱 Suporte a DOM: ${document?.getElementById != null ? 'Sim' : 'Não'}
    🕵️ Online: ${navigator.onLine ? 'Sim' : 'Não'}
    🛡️ Cookies habilitados: ${navigator.cookieEnabled ? 'Sim' : 'Não'}
    🧮 Número de núcleos (CPU): ${navigator.hardwareConcurrency || 'Desconhecido'}
        `;

        alert(info);
  }

}
